import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import block from 'bem-cn';

import TableRow from './TableRow/TableRow';

import './TableProviders.scss';

const b = block('reports-table-providers');

const TableProviders = ({ providers }) => {
  const locale = useSelector(state => state.locale.locale);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  const parseEuropeanNumber = str => {
    if (!str || typeof str !== 'string') return 0;
    const cleanStr = str.trim();
    if (cleanStr === '' || cleanStr === '0') return 0;
    const numberStr = cleanStr.replace(/\./g, '').replace(',', '.');
    const result = parseFloat(numberStr);
    return isNaN(result) ? 0 : result;
  };

  const filteredProviders = useMemo(
    () => providers.map(({ commissionBalance, ...props }) => ({ ...props })),
    [providers],
  );

  const headers = useMemo(
    () => (filteredProviders.length ? Object.keys(filteredProviders[0]) : []),
    [filteredProviders],
  );

  const sortedProviders = useMemo(() => {
    if (!sortConfig.key) return filteredProviders;

    return [...filteredProviders].sort((a, b) => {
      const aVal = parseEuropeanNumber(a[sortConfig?.key]);
      const bVal = parseEuropeanNumber(b[sortConfig?.key]);

      if (aVal === bVal) return 0;
      if (sortConfig.direction === 'asc') {
        return aVal > bVal ? 1 : -1;
      }
      return aVal < bVal ? 1 : -1;
    });
  }, [filteredProviders, sortConfig]);

  const rows = useMemo(
    () => sortedProviders?.map((item, idx) => <TableRow key={idx} item={item} />),
    [sortedProviders],
  );

  return (
    <div className={b()}>
      <div className={b('header')}>{locale.byProvider}</div>
      <table className={b('table')}>
        {!!filteredProviders.length ? (
          <>
            <div className={b('table-header')}>
              {headers.map(head => (
                <div key={head} className={b('table-head')}>
                  {locale[head]}
                </div>
              ))}
            </div>
            <div className={b('table-body')}>{rows}</div>
          </>
        ) : (
          <div className={b('no-results')}>{locale.noResults}</div>
        )}
      </table>
    </div>
  );
};

export default TableProviders;
